import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Clock } from 'lucide-react';
import { formatMinToHours } from '../../utils/common_functions';
import { Skeleton } from 'antd';
import {
  iconDevelopment,
  iconGraphic,
  iconQuality,
  iconManagement,
  billigcaricon
} from '../../utils/icon';

const getDepartmentIcon = (name) => {
  if (name?.includes('Development')) return [iconDevelopment, '#2F80ED'];
  if (name?.includes('UI/UX Design')) return [iconGraphic, '#F2994A'];
  if (name?.includes('Quality')) return [iconQuality, '#27AE60'];
  if (name?.includes('Management')) return [iconManagement, '#9B51E0'];
  return [iconDevelopment, '#9B51E0'];
};

const BillingCard = ({ data = [] }) => {
  return (
    <CardContainer>
      {data?.map((dept) => (
        <Card key={dept.department_id}>
          {billigcaricon}

          <Container>
            <DepartmentTitle>{dept?.project_name}</DepartmentTitle>
            <TimeInfo>
              <Clock size={16} /> {formatMinToHours(dept?.total_billable_mins)}
            </TimeInfo>
          </Container>
        </Card>
      ))}
    </CardContainer>
  );
};
const DepartmentCard = ({ data = [] }) => {
  const newdata = data?.map((el) => {
    return {
      icon: getDepartmentIcon(el?.department_name)?.[0],
      color: getDepartmentIcon(el?.department_name)?.[1],
      ...el,
      total_mins: el?.total_mins
    };
  });
  console.log(newdata, 'newdata');

  return (
    <CardContainer>
      {newdata?.map((dept) => (
        <Card key={dept.department_id}>
          {dept?.icon}

          <Container>
            <DepartmentTitle>{dept?.department_name}</DepartmentTitle>
            <TimeInfo style={{ color: dept?.color }}>
              <Clock size={16} /> {formatMinToHours(dept?.total_mins)}
            </TimeInfo>
          </Container>
        </Card>
      ))}
    </CardContainer>
  );
};

BillingCard.propTypes = {
  data: PropTypes.array
};
DepartmentCard.propTypes = {
  data: PropTypes.array
};

export { BillingCard, DepartmentCard };

export const SkeletonCard = () => {
  return (
    <CardContainer>
      {Array.from({ length: 7 }).map((_, i) => (
        <Card key={i} style={{ paddingTop: '5px', marginBottom: '0px', paddingBottom: 0 }}>
          <Skeleton active avatar paragraph={{ rows: 1 }} />
        </Card>
      ))}
    </CardContainer>
  );
};
const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  column-gap: 15px;
  row-gap: 15px;
  border-radius: 12px;
  max-height: 65vh;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    height: 0px;
    width: 0px;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.primaryColor};
    border-radius: 10px;
  }
`;

const Card = styled.div`
  width: 100%;
  height: fit-content;
  background: #fffdfdff;
  border-radius: 12px;
  padding: 12px 16px;
  transition: 0.3s;
  display: flex;
  flex-direction: column;
  align-items: start;
  &:hover {
    transform: translateY(-1.2px);
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
  }
`;

const DepartmentTitle = styled.p`
  font-family: Plus Jakarta Sans;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  padding: 0;
  margin-top: 10px;
  margin-bottom: 5px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  padding-left: 4px;
`;
const TimeInfo = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.primaryColor};
  font-family: Plus Jakarta Sans;
  font-weight: 500;
  font-style: SemiBold;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;

  svg {
    margin-right: 8px;
  }
`;
